import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import './style.less';

const DelAndRet = ({
  deliveryUsps,
  language,
  delLink,
  returnLink,
  app,
}) => {
  const { selections } = app;

  return (
    <div className="delivery-and-return">
      <div className="delivery-usps separator">
        {deliveryUsps.map((usp) => {
          // This is a hack
          // FIX ME(more like a backend thing)
          let { headline } = usp;
          if (language === 'da' && headline === '1-2 dages levering') {
            if (selections.sizeDetails !== undefined) {
              headline = `${selections.sizeDetails.delivery}s levering`;
            }
          }
          // END of hack

          return (
            <div className="deliveryItem" key={usp.headline || usp.icon}>
              <div className="deliveryTop">
                <div className="deliveryIcon">
                  {usp.icon ? (
                    <img
                      src={`data:image/svg+xml;base64,${usp.icon}`}
                      alt="icon"
                    />
                  ) : (
                    <div className="usp-checkmark" />
                  )}
                </div>
                {usp.headline && (
                  <div className="deliveryTitle text dt-bold">{headline}</div>
                )}
              </div>
              {usp.body && <div className="deliveryText text">{usp.body}</div>}
            </div>
          );
        })}
      </div>
      <div className="delivery-paragraphs">
        <div className="text br">
            <div>
              <div className="text br">
                <a
                  href={delLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="green-link br"
                >
                  {t`Read here for more information about delivery.`}
                </a>
              </div>
              <a
                href={returnLink}
                target="_blank"
                rel="noopener noreferrer"
                className="green-link"
              >
                {t`Read here for more information about returns.`}
              </a>
            </div>
        </div>
        {language !== 'en' && (
          <div>
            <div className="text br">{t`For deliveries outside the XXX border, we have an international site that can be accessed at the bottom of this website.`}</div>
            <div className="text">{t`For deliveries outside the Danish border, we have an international site that can be accessed at the bottom of this website.`}</div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ usp, general, app }) => {
  return {
    deliveryUsps: usp.delivery,
    language: general.language,
    delAndRetLink: general.local_data.delAndRetLink,
    returnLink: general.local_data.returnLink,
    delLink: general.local_data.delLink,
    app,
  };
};

export default connect(mapStateToProps)(DelAndRet);
